export type DqiValue = "overall" | "schema" | "volume" | "completeness" | "uniqueness" | "numeric" | "validity"

export interface DqiFilterOption {
  label: string
  value: DqiValue
}

export const DQI_OPTIONS: DqiFilterOption[] = [
  { label: "Overall", value: "overall" },
  { label: "Schema", value: "schema" },
  { label: "Volume", value: "volume" },
  { label: "Completeness", value: "completeness" },
  { label: "Uniqueness", value: "uniqueness" },
  { label: "Numeric", value: "numeric" },
  { label: "Validity", value: "validity" },
]

export const METRIC_TYPES = {
  DATA_HEALTH: "dataHealth",
  ACTIVE_COVERAGE: "activeCoverage",
  FAILED_EXPECTATIONS: "failedExpectations",
} as const

export type MetricType = (typeof METRIC_TYPES)[keyof typeof METRIC_TYPES]
